<app-direct-black-box
  *ngIf="loggedIn && directBlackBox && isBuyer"
  mode="default"
  [content]="directBlackBox"
></app-direct-black-box>

<footer *ngIf="loggedIn" data-testid="footer-medigi-section-logged-in">
  <div *ngIf="features.marketplaceNavigation" class="px-2 text-center">
    &copy;{{ copyrightYear }} Medigi LLC.
  </div>
</footer>

<footer *ngIf="loggedIn === false" class="static-footer" data-testid="footer-medigi-section-static">
  <div *ngIf="!mobileUser" class="container" data-testid="footer-medigi-section-desktop">
    <div class="footer-container">
      <div class="top-line">
        <div class="top-line-left-side">
          <a routerLink="/" data-testid="footer-medigi-link-home">home</a>
          <a routerLink="/pharmacy-info" data-testid="footer-medigi-link-pharmacies">pharmacies</a>
          <a routerLink="/manufacturer-info" data-testid="footer-medigi-link-manufacturers">manufacturers</a>
          <a routerLink="/about" data-testid="footer-medigi-link-about">about us</a>
          <a class="green" routerLink="/registration/buyer" data-testid="footer-medigi-link-register-pharmacy"
            >register pharmacy <i class="dx-icon-chevronright"></i
          ></a>
          <a class="green" routerLink="/registration/seller" data-testid="footer-medigi-link-register-manufacturer"
            >register manufacturer <i class="dx-icon-chevronright"></i
          ></a>
        </div>
        <div class="top-line-right-side">
          <img src="/assets/img/logos/medigi-logo-blue.svg" alt="medigi logo" />
        </div>
      </div>
      <div class="bottom-line">
        <div class="bottom-line-left-side">
          200 East Robinson Street, Suite 1250, Orlando, FL 32801 |
          <a class="green" href="tel: (844)-733-5633" data-testid="footer-medigi-link-phone">(844) 733-5633</a> |
          <a class="green" href="mailto:info@medigi.com" data-testid="footer-medigi-link-email">info&#64;medigi.com</a
          ><br />
          <small>&copy;{{ copyrightYear }} medigi | All Rights Reserved</small>
        </div>
        <div class="bottom-line-right-side">
          <img
            class="social"
            src="assets/img/static-pages/medigi/v2-images/company-logos/linkedin.svg"
            alt="Linked In"
            data-testid="footer-medigi-link-linkedin"
            (click)="
              goToSocials('https://www.linkedin.com/company/medigidirect')
            "
          />
          <img
            class="social"
            src="assets/img/static-pages/medigi/v2-images/company-logos/facebook.svg"
            alt="Facebook"
            data-testid="footer-medigi-link-facebook"
            (click)="goToSocials('https://www.facebook.com/medigidirect')"
          />
          <img
            class="social"
            src="assets/img/static-pages/medigi/v2-images/company-logos/twitter.svg"
            alt="Twitter"
            data-testid="footer-medigi-link-twitter"
            (click)="goToSocials('https://twitter.com/medigiDirect')"
          />
          <img
            class="social"
            src="assets/img/static-pages/medigi/v2-images/company-logos/insta.svg"
            alt="Instagram"
            data-testid="footer-medigi-link-instagram"
            (click)="goToSocials('https://www.instagram.com/medigidirect')"
          />
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="mobileUser" data-testid="footer-medigi-section-mobile">
    <div class="mobile-footer-container">
      <div class="mobile-top-line">
        <div>
          <img src="/assets/img/logos/medigi-logo-blue.svg" alt="medigi logo" />
        </div>
        <div class="bottom-line-right-side">
          <img
            src="assets/img/static-pages/medigi/v2-images/company-logos/linkedin.svg"
            alt="Linked In"
            data-testid="footer-medigi-link-linkedin-mobile"
            (click)="
              goToSocials('https://www.linkedin.com/company/medigidirect')
            "
          />
          <img
            src="assets/img/static-pages/medigi/v2-images/company-logos/facebook.svg"
            alt="Facebook"
            data-testid="footer-medigi-link-facebook-mobile"
            (click)="goToSocials('https://www.facebook.com/medigidirect')"
          />
          <img
            src="assets/img/static-pages/medigi/v2-images/company-logos/twitter.svg"
            alt="Twitter"
            data-testid="footer-medigi-link-twitter-mobile"
            (click)="goToSocials('https://twitter.com/medigiDirect')"
          />
          <img
            src="assets/img/static-pages/medigi/v2-images/company-logos/insta.svg"
            alt="Instagram"
            data-testid="footer-medigi-link-instagram-mobile"
            (click)="goToSocials('https://www.instagram.com/medigidirect')"
          />
        </div>
      </div>
      <div class="mobile-middle-line mt-3">
        <div class="links">
          <a routerLink="/" data-testid="footer-medigi-link-home-mobile">home</a>
          <a routerLink="/pharmacy-info" data-testid="footer-medigi-link-pharmacies-mobile">pharmacies</a>
          <a routerLink="/manufacturer-info" data-testid="footer-medigi-link-manufacturers-mobile">manufacturers</a>
          <a routerLink="/about" data-testid="footer-medigi-link-about-mobile">about us</a>
        </div>
        <div class="links">
          <a class="green" routerLink="/registration/buyer" data-testid="footer-medigi-link-register-pharmacy-mobile"
            >register pharmacy <i class="dx-icon-chevronright"></i
          ></a>
          <a class="green" routerLink="/registration/seller" data-testid="footer-medigi-link-register-manufacturer-mobile"
            >register manufacturer <i class="dx-icon-chevronright"></i
          ></a>
        </div>
      </div>
      <div class="bottom-line mt-3 mb-3">
        <div class="bottom-line-left-side">
          200 East Robinson Street, Suite 1250, Orlando, FL 32801 |
          <a class="green" href="tel: (844)-733-5633" data-testid="footer-medigi-link-phone-mobile">(844) 733-5633</a> |
          <a class="green" href="mailto:info@medigi.com" data-testid="footer-medigi-link-email-mobile">info&#64;medigi.com</a
          ><br />
          <small>&copy;{{ copyrightYear }} medigi | All Rights Reserved</small>
        </div>
      </div>
    </div>
  </div>
</footer>
